import clsx from 'clsx';
import {useAuthUser} from 'main/utility/AuthHooks';
import {checkPermission} from 'main/utility/helper/RouteHelper';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {BUSINESS_ROLE} from 'shared/constants/AppConst';
import VerticalCollapse from '../VerticalCollapse';
import VerticalItem from '../VerticalItem';
import VerticalNavGroupItem from './VerticalNavGroupItem';

const VerticalNavGroup = ({item, level}) => {
  const {user} = useAuthUser();
  const hasPermission = useMemo(
    () => checkPermission(item.permittedrole, user.role),
    [item.permittedrole, user.role],
  );

  if (!hasPermission) {
    return null;
  }
  return (
    <>
      <VerticalNavGroupItem
        level={level}
        component='div'
        className={clsx('nav-item nav-item-header')}
      >
        {item.title}
      </VerticalNavGroupItem>

      {item.children && (
        <>
          {item.children.map((item) => (
            <React.Fragment key={item.layoutid}>
              {item.menutype === 'group' && (
                <NavVerticalGroup item={item} level={level} />
              )}

              {item.menutype === 'collapse' && (
                <VerticalCollapse item={item} level={level} />
              )}

              {item.menutype === 'item' && (
                <VerticalItem item={item} level={level} />
              )}
            </React.Fragment>
          ))}
        </>
      )}
    </>
  );
};

VerticalNavGroup.propTypes = {
  item: PropTypes.shape({
    layoutid: PropTypes.string.isRequired,
    title: PropTypes.string,
    menutype: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    permittedrole: PropTypes.oneOf(Object.values(BUSINESS_ROLE)),
    children: PropTypes.array,
  }),
  level: PropTypes.number,
};

const NavVerticalGroup = VerticalNavGroup;

export default NavVerticalGroup;
